module.exports = __webpack_public_path__ + "static/expeditions-91d1a375229488bba164918e5c6e9b87.png";